import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import zionDebug from '@fs/zion-debug'
import { useStatusOverlay } from '@fs/zion-ui'

const debugError = zionDebug('zh:ErrorOverlay:error')

export default function useDataStatusOverlay() {
  const [t] = useTranslation()

  const showStatus = useStatusOverlay()

  const showSuccess = useCallback((message) => showStatus({ message, type: 'success', transient: true }), [showStatus])
  const showError = useCallback(
    (message, error) => {
      showStatus({
        dismissable: true,
        message: message || t('errors.general', 'An error occurred. Please try again later.'),
        type: 'error',
      })
      if (error) debugError(message, error)
    },
    [showStatus, t]
  )
  return { showSuccess, showError }
}

export function useSuccessOverlay() {
  return useDataStatusOverlay().showSuccess
}

export function useErrorOverlay() {
  return useDataStatusOverlay().showError
}
